<div class="container py-4 text-primary" *transloco="let t">

  <div class="row">
    <div class="col">
      <h1 class="text-primary ">
        Tu organises une activité de loisir?
      </h1>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <p class="my-2">En partageant ta passion, tu contribues à faire vivre ta région.</p>
    </div>
  </div>

  <div class="alert alert-info mt-2" role="alert">
    <p class="my-2">
      <lucide-icon [img]="icons.check"></lucide-icon> {{ t('activity.publish.guest.RegisterInfo') }}
    </p>
  </div>

  <app-login></app-login>

  <div class="row my-4">
    <div class="col">
      <app-activity-publish-rules></app-activity-publish-rules>
    </div>
  </div>


</div>
